import { useMemo, type ReactNode } from 'react'
import type { Scope } from './scope'
import { ScopeContext } from './scopeContext'

interface ScopeProviderProps {
  scope: Scope | undefined
  children?: ReactNode
}

/** Makes `scope` the ambient scope for every enablement check rendered beneath it. */
export function ScopeProvider({ scope, children }: ScopeProviderProps) {
  const entityTypeId = scope?.entityTypeId
  const value = useMemo(
    () => (entityTypeId === undefined ? undefined : { entityTypeId }),
    [entityTypeId],
  )
  return <ScopeContext.Provider value={value}>{children}</ScopeContext.Provider>
}
